export default {
  data() {
    return {};
  }, //data
  computed: {},
  methods: {
    checkRulesAndRedirect(to, next) {
      // Simplified permission check - allow authenticated users access
      // Backend API handles detailed authorization
      const user = this.$store.getters["App/user"];

      if (!user || !user.id) {
        // Only block if user is not authenticated
        this.$eventbus.emit("ComponentToast/add", {
          autoHide: true,
          content: "Você precisa estar autenticado para acessar esta tela",
          icon: null,
          showCloseButton: false,
          type: "error",
        });

        if (next) {
          next({ name: "AccessDenied" });
        } else {
          this.$router.replace({ name: "AccessDenied" });
        }
      } else {
        // User is authenticated, allow access
        if (next) {
          next();
        }
      }
    },
  }, //methods
  watch: {}, //watch
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.meta) {
        if (to.meta.rules) {
          vm.checkRulesAndRedirect(to);
        }
      }
    });
  }, //beforeRouteEnter
  beforeRouteUpdate(to, from, next) {
    if (to.meta) {
      if (to.meta.rules) {
        this.checkRulesAndRedirect(to, next);
      } else {
        next();
      }
    } else {
      next();
    }
  }, //beforeRouteUpdate
  beforeRouteLeave(to, from, next) {
    next();
  }, //beforeRouteLeave
  created() {}, //created
  beforeMount() {
    const lsUser = localStorage.getItem("ordexa/user");

    if (lsUser) {
      const user = JSON.parse(lsUser);

      this.$store.dispatch("App/setUser", user);

      this.$ability.update(this.$helpers.processRules(user.rules));
    }
  }, //beforeMount
  mounted() {}, //mounted
};
